export default function getThumbnail(thumbnails) {
  if (!thumbnails) {
    return;
  }

  const biggestThumbnail = _(thumbnails)
    .values()
    .maxBy('width');

  return biggestThumbnail.url.replace(/^https?:/, '');
}



// WEBPACK FOOTER //
// ./src/transport/adapters/youtube/parsers/get-thumbnail.js